// extracted by mini-css-extract-plugin
export default {"container":"Answer_container__bBev8"};